export default __webpack_public_path__ + "static/media/celestial-background.97337b6d.jpg";